import { apiClient } from './client';
import type {
  Constraint,
  CreateConstraintRequest,
  MealExclusion,
  CreateExclusionRequest,
} from '@/types/api';

export async function createConstraint(
  data: CreateConstraintRequest,
): Promise<Constraint> {
  const response = await apiClient.post<Constraint>('/constraints', data);
  return response.data;
}

export async function getConstraints(userId?: number): Promise<Constraint[]> {
  const response = await apiClient.get<Constraint[]>('/constraints', {
    params: userId !== undefined ? { userId } : undefined,
  });
  return response.data;
}

export async function deleteConstraint(id: number): Promise<void> {
  await apiClient.delete(`/constraints/${id}`);
}

export async function createMealExclusion(
  data: CreateExclusionRequest,
): Promise<MealExclusion> {
  const response = await apiClient.post<MealExclusion>(
    '/meal-exclusions',
    data,
  );
  return response.data;
}

export async function getMealExclusions(
  userId?: number,
): Promise<MealExclusion[]> {
  const response = await apiClient.get<MealExclusion[]>('/meal-exclusions', {
    params: userId !== undefined ? { userId } : undefined,
  });
  return response.data;
}

export async function getMealExclusionsByMeal(
  mealId: number,
): Promise<MealExclusion[]> {
  const response = await apiClient.get<MealExclusion[]>('/meal-exclusions', {
    params: { mealId },
  });
  return response.data;
}

export async function deleteMealExclusion(id: number): Promise<void> {
  await apiClient.delete(`/meal-exclusions/${id}`);
}
